/*=========================================================================================
  File Name: moduleScheduleActions.js
  Description: Schedule Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Api from "@/helpers/api.js";

export default {
	save({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/time_window", payload)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	update({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.put(`/time_window/${payload.id}`, payload.items)
				.then((response) => {
					commit("UPDATE_TIME_WINDOW", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	findTimeWindowSimulate({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/time_window/simulate", payload)
				.then((response) => {
					commit("SET_SCHEDULE_EVENTS_TIME_WINDOW", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	timeWindowFilter({commit}, data) {
		return new Promise((resolve, reject) => {
			const payload = {
				page: data.page || 1,
				quantity: data.quantity || 1000000,
				fields: [
					"id",
					"name",
					"description",
					"cron",
					"duration",
					"added_on",
					"update_on",
					"visit_point_id",
					"before_soft_duration",
					"after_soft_duration",
					"before_soft_cost",
					"after_soft_cost",
				],
				id: data.id || [],
				name: data.name || [],
				description: data.description || [],
				cron: data.cron || [],
				duration: data.duration || [],
				visit_points_id: data.visit_points_id || [],
				before_soft_duration: data.before_soft_duration || [],
				after_soft_duration: data.after_soft_duration || [],
				before_soft_cost: data.before_soft_cost || [],
				after_soft_cost: data.after_soft_cost || [],
				match_filter: data.match_filter,
				order_by: data.order_by || ["name"],
				sort: data.sort || "asc",
			};
			Api.post("/time_window/filter", payload)
				.then((res) => {
					commit("SET_TIME_WINDOW", res.data.records);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	timeWindowAssigned({commit}, data) {
		return new Promise((resolve, reject) => {
			const payload = {
				page: data.page || 1,
				quantity: data.quantity || 1000000,
				fields: ["id", "name", "description", "cron", "duration", "added_on", "update_on", "visit_point_id"],
				id: data.id || [],
				name: data.name || [],
				description: data.description || [],
				cron: data.cron || [],
				duration: data.duration || [],
				visit_points_id: data.visit_points_id || [],
				match_filter: data.match_filter,
				order_by: data.order_by || ["name"],
				sort: data.sort || "asc",
			};
			Api.post("/time_window/filter", payload)
				.then((res) => {
					commit("SET_ASSIGNED_TIME_WINDOW", res.data.records);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	deleteById({commit}, id) {
		return new Promise((resolve, reject) => {
			Api.delete(`/time_window/${id}`)
				.then((response) => {
					commit("REMOVE_TIME_WINDOW", id);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchEvents({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/api/apps/calendar/events")
				.then((response) => {
					commit("SET_EVENTS", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	eventDragged({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post(`/api/apps/calendar/event/dragged/${payload.event.id}`, {
				payload,
			})
				.then((response) => {
					// Convert Date String to Date Object
					const event = response.data;
					event.startDate = new Date(event.startDate);
					event.endDate = new Date(event.endDate);
					commit("UPDATE_EVENT", event);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	cleanEvents({commit}) {
		commit("CLEAN_EVENTS");
	},
	findAll() {
		return new Promise((resolve, reject) => {
			Api.get("/time_window")
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
};
